import { render, staticRenderFns } from "./senior.vue?vue&type=template&id=39b31bb3&scoped=true&"
import script from "./senior.vue?vue&type=script&lang=js&"
export * from "./senior.vue?vue&type=script&lang=js&"
import style0 from "./senior.vue?vue&type=style&index=0&id=39b31bb3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b31bb3",
  null
  
)

export default component.exports